<div class="create-management">
  <div class="page-header">
    <div>
      <h2>创建管理</h2>
      <p>分别控制小程序中的创建祠堂、创建追忆入口。</p>
    </div>
    <button type="button" class="secondary-btn" :disabled="loading || saving" @click="fetchSettings">
      刷新
    </button>
  </div>

  <p class="permission-note">
    开启后，普通用户可见对应入口，登录后可创建；平台管理员始终可见并可创建。开关默认关闭，仅控制创建权限，已有内容的管理权限沿用原规则。
  </p>

  <div v-if="loading" class="state-panel" role="status">正在加载创建设置…</div>
  <div v-else-if="loadError" class="state-panel error-panel" role="alert">
    <p>{{ loadError }}</p>
    <button type="button" class="secondary-btn" @click="fetchSettings">重试</button>
  </div>

  <form v-else-if="loaded" class="settings-panel" @submit.prevent="handleSave">
    <div class="setting-row">
      <div class="setting-description">
        <label for="hall-creation-enabled" class="setting-title">创建祠堂</label>
        <p id="hall-creation-description">允许普通用户从小程序创建祠堂。</p>
      </div>
      <label class="switch-control">
        <input
          id="hall-creation-enabled"
          v-model="form.hall_creation_enabled"
          type="checkbox"
          role="switch"
          aria-describedby="hall-creation-description"
          :aria-checked="form.hall_creation_enabled"
          :disabled="saving"
          @change="clearFeedback"
        />
        <span class="switch-track" aria-hidden="true"></span>
        <span class="switch-label">{{ form.hall_creation_enabled ? '已开启' : '已关闭' }}</span>
      </label>
    </div>

    <div class="setting-row">
      <div class="setting-description">
        <label for="memorial-creation-enabled" class="setting-title">创建追忆</label>
        <p id="memorial-creation-description">允许普通用户从小程序创建追忆。</p>
      </div>
      <label class="switch-control">
        <input
          id="memorial-creation-enabled"
          v-model="form.memorial_creation_enabled"
          type="checkbox"
          role="switch"
          aria-describedby="memorial-creation-description"
          :aria-checked="form.memorial_creation_enabled"
          :disabled="saving"
          @change="clearFeedback"
        />
        <span class="switch-track" aria-hidden="true"></span>
        <span class="switch-label">{{ form.memorial_creation_enabled ? '已开启' : '已关闭' }}</span>
      </label>
    </div>

    <div class="settings-footer">
      <div class="feedback" aria-live="polite">
        <span v-if="saveError" class="error-message" role="alert">{{ saveError }}</span>
        <span v-else-if="successMessage" class="success-message">{{ successMessage }}</span>
        <span v-else-if="hasChanges" class="unsaved-message">有未保存的修改</span>
      </div>
      <button type="submit" class="primary-btn" :disabled="saving || !hasChanges">
        {{ saving ? '保存中…' : '保存设置' }}
      </button>
    </div>
  </form>
</div>
